import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { getVisitorStatsAPI } from 'src/constant/api/visitorAPI';

export interface IMonthlyData {
    month: string;
    year: number;
    visitors: number;
    unique: number;
}

export interface IVisitorState {
    totalVisitors: number;
    uniqueVisitors: number;
    monthlyData: IMonthlyData[];
    status: 'idle' | 'loading' | 'succeeded' | 'failed';
    error: string | null;
}

const initialState: IVisitorState = {
    totalVisitors: 0,
    uniqueVisitors: 0,
    monthlyData: [],
    status: 'idle',
    error: null,
};

export const fetchVisitorStats = createAsyncThunk<
    { totalVisitors: number; uniqueVisitors: number; monthlyData: IMonthlyData[] },
    void
>('visitor/fetchVisitorStats', async (_, { rejectWithValue }) => {
    try {
        const { data } = await getVisitorStatsAPI();
        return data;
    } catch (error: any) {
        return rejectWithValue(error?.response?.data?.message || error.message);
    }
});

export const visitorSlice = createSlice({
    name: 'visitor',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchVisitorStats.pending, (state) => {
                state.status = 'loading';
                state.error = null;
            })
            .addCase(fetchVisitorStats.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.totalVisitors = action.payload.totalVisitors;
                state.uniqueVisitors = action.payload.uniqueVisitors;
                state.monthlyData = action.payload.monthlyData;
            })
            .addCase(fetchVisitorStats.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.payload as string;
            });
    },
});

export default visitorSlice.reducer;
